import React from 'react';
import { MarkdownRenderer } from '../common';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

// Convert relative URLs to absolute URLs pointing to the API server
const getMediaUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('/uploads/')) {
    return `${API_URL}${url}`;
  }
  return url;
};

export const PromptDisplay = ({ prompt, showMedia = true }) => {
  if (!prompt || !prompt.content) {
    return (
      <div className="bg-gray-50 rounded-lg p-6 text-center text-gray-500">
        No prompt set yet. Waiting for GM...
      </div>
    );
  }

  return (
    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
      <div className="bg-primary-50 px-4 py-2 border-b border-gray-200">
        <h3 className="font-semibold text-primary-900">GM's Prompt</h3>
      </div>

      <div className="p-4">
        {/* Media attachment */}
        {showMedia && prompt.mediaUrl && (
          <div className="mb-4">
            {prompt.mediaType === 'image' && (
              <img
                src={getMediaUrl(prompt.mediaUrl)}
                alt="Prompt attachment"
                className="w-full max-h-64 object-cover rounded-lg"
              />
            )}
            {prompt.mediaType === 'audio' && (
              <audio
                controls
                src={getMediaUrl(prompt.mediaUrl)}
                className="w-full"
              />
            )}
          </div>
        )}

        {/* Prompt text */}
        <div className="prose prose-sm max-w-none">
          <MarkdownRenderer content={prompt.content} />
        </div>

        {/* Timestamp */}
        {prompt.createdAt && (
          <p className="text-xs text-gray-400 mt-4">
            Posted {new Date(prompt.createdAt).toLocaleString()}
          </p>
        )}
      </div>
    </div>
  );
};
